<app-loader *ngIf="isLoading"></app-loader>

<div class="header-container">
  <app-header></app-header>
</div>

<main class="min-h-screen bg-[#F2F3F5] font-sans">
  <div class="flex flex-col lg:flex-row">
    <!-- Stepper Sidebar -->
    <aside
      class="w-full lg:w-[20%] flex-shrink-0 bg-white lg:bg-transparent border-b lg:border-b-0"
    >
      <app-stepper [currentStep]="5"></app-stepper>
    </aside>

    <!-- Main Content -->
    <div class="flex-1 w-full p-4 sm:p-6 lg:p-8 mx-auto">
      <h1 class="text-xl sm:text-3xl font-bold text-gray-800 mb-2 sm:mb-4">
        {{ "PAYMENT.COMPLETE_PAYMENT" | translate }}
      </h1>
      <p class="text-gray-600 text-sm sm:text-base mb-6">
        {{ "PAYMENT.PAGE_DESC" | translate }}
      </p>

      <div class="flex flex-col lg:flex-row gap-6">
        <!-- Left Section -->
        <div class="flex-1 flex-col gap-2">
          <!-- VAT Number Section -->
          <div class="bg-white rounded-xl shadow-sm p-6 mb-6 border">
            <div class="flex items-center gap-3 mb-6">
              <svg width="40" height="40" viewBox="0 0 28 28" fill="none">
                <rect width="28" height="28" rx="8.75" fill="#FFEDD4" />
                <path
                  d="M15.7497 8.16602H10.4997C10.1903 8.16602 9.89351 8.28893 9.67472 8.50772C9.45592 8.72652 9.33301 9.02326 9.33301 9.33268V18.666C9.33301 18.9754 9.45592 19.2722 9.67472 19.491C9.89351 19.7098 10.1903 19.8327 10.4997 19.8327H17.4997C17.8091 19.8327 18.1058 19.7098 18.3246 19.491C18.5434 19.2722 18.6663 18.9754 18.6663 18.666V11.0827L15.7497 8.16602Z"
                  stroke="#F54900"
                  stroke-width="1.16667"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M15.167 8.16602V10.4993C15.167 10.8088 15.2899 11.1055 15.5087 11.3243C15.7275 11.5431 16.0242 11.666 16.3337 11.666H18.667"
                  stroke="#F54900"
                  stroke-width="1.16667"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M12.8337 12.25H11.667"
                  stroke="#F54900"
                  stroke-width="1.16667"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M16.3337 14.584H11.667"
                  stroke="#F54900"
                  stroke-width="1.16667"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M16.3337 16.916H11.667"
                  stroke="#F54900"
                  stroke-width="1.16667"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <h2 class="text-lg text-black">
                {{ "PAYMENT.ENTER_COMPANY_VAT_NUMBER" | translate }}
              </h2>
            </div>

            <div class="space-y-6">
              <div>
                <label class="block text-sm font-semibold text-black mb-2">{{
                  "PAYMENT.COMPANY_VAT_NUMBER" | translate
                }}</label>
                <input
                  type="text"
                  [(ngModel)]="vatNumber"
                  #vatNumberRef="ngModel"
                  [disabled]="noVatNumber"
                  [placeholder]="'PAYMENT.ENTER_VAT_NUMBER' | translate"
                  maxlength="15"
                  class="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500 text-gray-900 disabled:bg-gray-100 disabled:cursor-not-allowed bg-gray-100"
                  [pattern]="noVatNumber ? '' : '^[0-9]{0,15}$'"
                />
                <div
                  *ngIf="
                    vatNumberRef.invalid && vatNumberRef.touched && !noVatNumber
                  "
                >
                  <span class="text-red-500 text-sm">
                    {{ "PAYMENT.VAT_ERROR_MESSAGE" | translate }}
                  </span>
                </div>
              </div>

              <label class="flex items-center gap-2 cursor-pointer">
                <input
                  type="checkbox"
                  [(ngModel)]="noVatNumber"
                  (change)="toggleVatValidation()"
                  class="w-4 h-4 accent-black border-gray-300 rounded focus:ring-blue-500 cursor-pointer"
                />
                <span class="text-sm text-black font-semibold">{{
                  "PAYMENT.NO_VAT_NUMBER" | translate
                }}</span>
              </label>
            </div>
          </div>
          <!-- Payment Details -->
          <div class="bg-white rounded-xl shadow-sm overflow-hidden border">
            <div class="p-4 sm:p-6">
              <!-- Payment Details -->
              <h2 class="text-base sm:text-md font-semibold text-gray-800 mb-4">
                {{ "PAYMENT.PAYMENT_DETAILS" | translate }}
              </h2>

              <!-- Selected Quote -->
              <div
                class="bg-teal-50 border border-teal-100 rounded-lg p-4 mb-6"
              >
                <p class="text-sm text-[#0B4F4A] mb-3 font-semibold">
                  {{ "PAYMENT.SELECTED_QUOTE" | translate }}
                </p>
                <div
                  class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3"
                >
                  <div class="flex items-center gap-3">
                    <div
                      class="w-10 h-10 bg-teal-600 rounded-lg flex items-center justify-center text-white font-semibold"
                      *ngIf="quotationDetail?.providerName as providerName"
                    >
                      {{ getProviderAvatarText(providerName) | uppercase }}
                    </div>
                    <div>
                      <h3 class="font-semibold text-[#0B4F4A]">
                        {{ quotationDetail?.providerName }} -
                        {{ "PAYMENT.PREMIUM" | translate }}
                      </h3>
                      <p class="text-xs text-teal-600">
                        {{ quotationDetail?.quoteRequest?.primaryCount }}
                        {{ "PAYMENT.MEMBERS" | translate }} •
                        {{ "PAYMENT.REFERENCE" | translate }}
                        {{ quotaReferenceNo }}
                      </p>
                    </div>
                  </div>
                  <div class="text-right">
                    <p class="text-lg sm:text-xl font-bold text-[#0B4F4A]">
                      {{ costBreakdown.annualPremium | number : "1.2-2" }} SAR
                    </p>
                    <p class="text-xs text-teal-600 font-medium">
                      {{ "PAYMENT.ANNUAL_PREMIUM" | translate }}
                    </p>
                  </div>
                </div>
              </div>

              <!-- Cost Breakdown -->
              <div class="mb-6">
                <h3 class="text-base font-semibold text-gray-800 mb-4">
                  {{ "PAYMENT.COST_BREAKDOWN" | translate }}
                </h3>
                <div class="space-y-3">
                  <div class="flex justify-between text-sm">
                    <span class="text-gray-600"
                      >{{ "PAYMENT.ANNUAL_PREMIUM" | translate }} ({{
                        quotationDetail?.quoteRequest?.primaryCount
                      }}
                      members)</span
                    >
                    <span class="text-gray-800 font-medium"
                      >{{
                        costBreakdown.annualPremium | number : "1.2-2"
                      }}
                      SAR</span
                    >
                  </div>
                  <div class="flex justify-between text-sm">
                    <span class="text-gray-600">{{
                      "PAYMENT.PROCESSING_FEE" | translate
                    }}</span>
                    <span class="text-gray-800 font-medium"
                      >{{
                        costBreakdown.processingFee | number : "1.2-2"
                      }}
                      SAR</span
                    >
                  </div>
                  <div class="flex justify-between text-sm">
                    <span class="text-gray-600">{{
                      "PAYMENT.VAT_15" | translate
                    }}</span>
                    <span class="text-gray-800 font-medium"
                      >{{ costBreakdown.vat | number : "1.2-2" }} SAR</span
                    >
                  </div>
                  <div
                    class="border-t border-gray-200 pt-3 mt-3 flex justify-between"
                  >
                    <span class="text-base font-semibold text-gray-800">{{
                      "PAYMENT.TOTAL_AMOUNT" | translate
                    }}</span>
                    <span class="text-lg font-bold text-teal-600"
                      >{{ costBreakdown.total | number : "1.2-2" }} SAR</span
                    >
                  </div>
                </div>
              </div>

              <!-- Payment Method -->
              <div>
                <h3 class="text-base font-semibold text-gray-800 mb-4">
                  {{ "PAYMENT.PAYMENT_METHOD" | translate }}
                </h3>
                <div class="grid grid-cols-3 gap-3 mb-4">
                  <!-- Credit Card -->
                  <button
                    type="button"
                    (click)="selectPaymentMethod('credit_card')"
                    [class.bg-gray-900]="paymentMethod === 'credit_card'"
                    [class.text-white]="paymentMethod === 'credit_card'"
                    [class.bg-white]="paymentMethod !== 'credit_card'"
                    [class.text-black]="paymentMethod !== 'credit_card'"
                    class="border border-gray-200 rounded-lg p-4 flex flex-col items-center justify-center gap-4 hover:border-teal-500 transition-colors"
                  >
                    <span
                      class="material-icons text-5xl"
                      [class.text-white]="paymentMethod === 'credit_card'"
                      [class.text-blue-600]="paymentMethod !== 'credit_card'"
                    >
                      credit_card
                    </span>
                    <span class="text-sm font-medium">{{ "PAYMENT.CREDIT_CARD" | translate }} </span>
                    <span
                      class="text-xs"
                      [class.text-gray-300]="paymentMethod === 'credit_card'"
                      [class.text-gray-500]="paymentMethod !== 'credit_card'"
                    >
                      Visa, Mastercard, Mada
                    </span>
                  </button>

                  <!-- Apple Pay -->
                  <button
                    type="button"
                    (click)="selectPaymentMethod('apple_pay')"
                    [class.bg-gray-900]="paymentMethod === 'apple_pay'"
                    [class.text-white]="paymentMethod === 'apple_pay'"
                    [class.bg-white]="paymentMethod !== 'apple_pay'"
                    [class.text-black]="paymentMethod !== 'apple_pay'"
                    class="border border-gray-200 rounded-lg p-4 flex flex-col items-center justify-center gap-4 hover:border-teal-500 transition-colors"
                  >
                    <span
                      class="material-icons text-5xl"
                      [class.text-white]="paymentMethod === 'apple_pay'"
                      [class.text-gray-800]="paymentMethod !== 'apple_pay'"
                    >
                      apple
                    </span>
                    <span class="text-sm font-medium">{{
                      "PAYMENT.APPLE_PAY" | translate
                    }}</span>
                    <span
                      class="text-xs"
                      [class.text-gray-300]="paymentMethod === 'apple_pay'"
                      [class.text-gray-500]="paymentMethod !== 'apple_pay'"
                    >
                      Fast & Secure
                    </span>
                  </button>

                  <!-- STC Pay -->
                  <button
                    type="button"
                    (click)="selectPaymentMethod('stc_pay')"
                    [class.bg-gray-900]="paymentMethod === 'stc_pay'"
                    [class.text-white]="paymentMethod === 'stc_pay'"
                    [class.bg-white]="paymentMethod !== 'stc_pay'"
                    [class.text-black]="paymentMethod !== 'stc_pay'"
                    class="border border-gray-200 rounded-lg p-4 flex flex-col items-center justify-center gap-4 hover:border-teal-500 transition-colors"
                  >
                    <span
                      class="material-icons text-5xl"
                      [class.text-white]="paymentMethod === 'stc_pay'"
                      [class.text-purple-600]="paymentMethod !== 'stc_pay'"
                    >
                      account_balance_wallet
                    </span>
                    <span class="text-sm font-medium">{{
                      "PAYMENT.STC_PAY" | translate
                    }}</span>
                    <span
                      class="text-xs"
                      [class.text-gray-300]="paymentMethod === 'stc_pay'"
                      [class.text-gray-500]="paymentMethod !== 'stc_pay'"
                    >
                      Mobile Wallet
                    </span>
                  </button>
                </div>

                <form [formGroup]="paymentForm">
                  <!-- Credit Card Form -->
                  <div
                    *ngIf="paymentMethod === 'credit_card'"
                    class="space-y-4"
                  >
                    <div class="grid grid-cols-2 gap-4">
                      <!-- Card Number -->
                      <div>
                        <label
                          class="block text-sm font-semibold text-black mb-1.5"
                        >
                          {{ "PAYMENT.CARD_NUMBER" | translate }}
                        </label>
                        <input
                          type="text"
                          [placeholder]="
                            'PAYMENT.PLACEHOLDERS.CARD_NUMBER' | translate
                          "
                          formControlName="cardNumber"
                          maxlength="16"
                          class="w-full px-4 py-2.5 border rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent bg-gray-100"
                        />
                        <div
                          *ngIf="
                            paymentForm.get('cardNumber')?.invalid &&
                            (paymentForm.get('cardNumber')?.touched ||
                              paymentForm.get('cardNumber')?.dirty)
                          "
                          class="text-red-600 text-xs mt-1"
                        >
                          <span
                            *ngIf="paymentForm.get('cardNumber')?.errors?.['required']"
                          >
                            {{ "PAYMENT.CARD_NUMBER_REQUIRED" | translate }}
                          </span>
                          <span
                            *ngIf="paymentForm.get('cardNumber')?.errors?.['pattern']"
                          >
                            {{ "PAYMENT.CARD_NUMBER_PATTERN" | translate }}
                          </span>
                        </div>
                      </div>

                      <!-- Expiry Date -->
                      <div>
                        <label
                          class="block text-sm font-semibold text-black mb-1.5"
                        >
                          {{ "PAYMENT.EXPIRY_DATE" | translate }}
                        </label>
                        <input
                          type="text"
                          [placeholder]="
                            'PAYMENT.PLACEHOLDERS.EXPIRY_DATE' | translate
                          "
                          formControlName="expiryDate"
                          maxlength="5"
                          class="w-full px-4 py-2.5 border rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent bg-gray-100"
                        />
                        <div
                          *ngIf="
                            paymentForm.get('expiryDate')?.invalid &&
                            (paymentForm.get('expiryDate')?.touched ||
                              paymentForm.get('expiryDate')?.dirty)
                          "
                          class="text-red-600 text-xs mt-1"
                        >
                          <span
                            *ngIf="paymentForm.get('expiryDate')?.errors?.['required']"
                          >
                            {{ "PAYMENT.EXPIRY_DATE_REQUIRED" | translate }}
                          </span>
                          <span
                            *ngIf="paymentForm.get('expiryDate')?.errors?.['pattern']"
                          >
                            {{ "PAYMENT.EXPIRY_DATE_PATTERN" | translate }}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div class="grid grid-cols-2 gap-4">
                      <!-- CVV -->
                      <div>
                        <label
                          class="block text-sm font-semibold text-black mb-1.5"
                        >
                          {{ "PAYMENT.CVV" | translate }}
                        </label>
                        <input
                          type="text"
                          [placeholder]="'PAYMENT.PLACEHOLDERS.CVV' | translate"
                          formControlName="cvv"
                          maxlength="4"
                          class="w-full px-4 py-2.5 border rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent bg-gray-100"
                        />
                        <div
                          *ngIf="
                            paymentForm.get('cvv')?.invalid &&
                            (paymentForm.get('cvv')?.touched ||
                              paymentForm.get('cvv')?.dirty)
                          "
                          class="text-red-600 text-xs mt-1"
                        >
                          <span
                            *ngIf="paymentForm.get('cvv')?.errors?.['required']"
                          >
                            {{ "PAYMENT.CVV_REQUIRED" | translate }}
                          </span>
                          <span
                            *ngIf="paymentForm.get('cvv')?.errors?.['pattern']"
                          >
                            {{ "PAYMENT.CVV_PATTERN" | translate }}
                          </span>
                        </div>
                      </div>

                      <!-- Cardholder Name -->
                      <div>
                        <label
                          class="block text-sm font-semibold text-black mb-1.5"
                        >
                          {{ "PAYMENT.CARDHOLDER_NAME" | translate }}
                        </label>
                        <input
                          type="text"
                          [placeholder]="'PAYMENT.FULL_NAME' | translate"
                          formControlName="cardHolderName"
                          class="w-full px-4 py-2.5 border rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent bg-gray-100"
                        />
                        <div
                          *ngIf="
                            paymentForm.get('cardHolderName')?.invalid &&
                            (paymentForm.get('cardHolderName')?.touched ||
                              paymentForm.get('cardHolderName')?.dirty)
                          "
                          class="text-red-600 text-xs mt-1"
                        >
                          <span
                            *ngIf="paymentForm.get('cardHolderName')?.errors?.['required']"
                          >
                            {{ "PAYMENT.CARDHOLDER_NAME_REQUIRED" | translate }}
                          </span>
                          <span
                            *ngIf="paymentForm.get('cardHolderName')?.errors?.['minlength']"
                          >
                            {{
                              "PAYMENT.CARDHOLDER_NAME_MINLENGTH" | translate
                            }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- STC Pay Form -->
                  <div
                    *ngIf="paymentMethod === 'stc_pay'"
                    class="space-y-5 mt-6"
                  >
                    <!-- STC Mobile Number -->
                    <div>
                      <label
                        class="block text-sm font-semibold text-black mb-1.5"
                      >
                        {{ "PAYMENT.STC_MOBILE_NUMBER" | translate }}
                      </label>
                      <input
                        type="tel"
                        [placeholder]="
                          'PAYMENT.PLACEHOLDERS.STC_MOBILE' | translate
                        "
                        formControlName="stcMobileNumber"
                        maxlength="10"
                        class="w-full px-4 py-2.5 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#009688] focus:border-transparent bg-gray-100"
                      />
                      <div
                        *ngIf="
                          paymentForm.get('stcMobileNumber')?.invalid &&
                          (paymentForm.get('stcMobileNumber')?.touched ||
                            paymentForm.get('stcMobileNumber')?.dirty)
                        "
                        class="text-red-600 text-xs mt-1"
                      >
                        <span
                          *ngIf="paymentForm.get('stcMobileNumber')?.errors?.['required']"
                        >
                          {{ "PAYMENT.MOBILE_NUMBER_REQUIRED" | translate }}
                        </span>
                        <span
                          *ngIf="paymentForm.get('stcMobileNumber')?.errors?.['pattern']"
                        >
                          {{ "PAYMENT.MOBILE_NUMBER_PATTERN" | translate }}
                        </span>
                      </div>
                    </div>

                    <!-- Branch -->
                    <div>
                      <label
                        class="block text-sm font-semibold text-black mb-1.5"
                      >
                        {{ "PAYMENT.BRANCH" | translate }}
                      </label>
                      <input
                        type="text"
                        [placeholder]="
                          'PAYMENT.PLACEHOLDERS.BRANCH_NAME' | translate
                        "
                        formControlName="stcBranch"
                        class="w-full px-4 py-2.5 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#009688] focus:border-transparent bg-gray-100"
                      />
                      <div
                        *ngIf="
                          paymentForm.get('stcBranch')?.invalid &&
                          (paymentForm.get('stcBranch')?.touched ||
                            paymentForm.get('stcBranch')?.dirty)
                        "
                        class="text-red-600 text-xs mt-1"
                      >
                        <span
                          *ngIf="paymentForm.get('stcBranch')?.errors?.['required']"
                        >
                          {{ "PAYMENT.BRANCH_REQUIRED" | translate }}
                        </span>
                      </div>
                    </div>

                    <!-- Cashier -->
                    <div>
                      <label
                        class="block text-sm font-semibold text-black mb-1.5"
                      >
                        {{ "PAYMENT.CASHIER" | translate }}
                      </label>
                      <input
                        type="text"
                        [placeholder]="
                          'PAYMENT.PLACEHOLDERS.CASHIER_NAME' | translate
                        "
                        formControlName="stcCashier"
                        class="w-full px-4 py-2.5 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#009688] focus:border-transparent bg-gray-100"
                      />
                      <div
                        *ngIf="
                          paymentForm.get('stcCashier')?.invalid &&
                          (paymentForm.get('stcCashier')?.touched ||
                            paymentForm.get('stcCashier')?.dirty)
                        "
                        class="text-red-600 text-xs mt-1"
                      >
                        <span
                          *ngIf="paymentForm.get('stcCashier')?.errors?.['required']"
                        >
                          {{ "PAYMENT.CASHIER_REQUIRED" | translate }}
                        </span>
                      </div>
                    </div>

                    <!-- STC Pay Info -->
                    <div
                      class="bg-[#E6FFFA] border border-[#009688] rounded-lg p-4 flex items-start gap-3 mt-3"
                    >
                      <span class="material-icons text-[#009688] text-xl"
                        >info</span
                      >
                      <div class="text-sm">
                        <p class="font-semibold text-[#005F5A]">
                          {{ "PAYMENT.STC_PAY_PAYMENT" | translate }}
                        </p>
                        <p class="text-[#006B65]">
                          {{ "PAYMENT.STC_PAY_NOTIFICATION" | translate }}
                        </p>
                      </div>
                    </div>
                  </div>
                </form>

                <!-- Apple Pay Form -->
                <div
                  *ngIf="paymentMethod === 'apple_pay'"
                  class="space-y-5 mt-6 bprder bg-gray-100 p-4 rounded-xl"
                >
                  <div class="flex items-center gap-3 mb-4">
                    <span class="material-icons text-black text-3xl"
                      >apple</span
                    >
                    <div>
                      <h3 class="text-lg font-semibold text-gray-800">
                        {{ "PAYMENT.APPLE_PAY_TITLE" | translate }}
                      </h3>
                      <p class="text-sm text-gray-500">
                        {{ "PAYMENT.APPLE_PAY_DESC" | translate }}
                      </p>
                    </div>
                  </div>

                  <div class="text-center py-10">
                    <div class="mb-6">
                      <span class="material-icons text-8xl text-black mb-4"
                        >apple</span
                      >
                    </div>
                    <p class="text-gray-700 text-lg mb-2">
                      {{ "PAYMENT.COMPLETE_PURCHASE_APPLE_PAY" | translate }}
                    </p>
                    <p class="text-gray-500 mb-8">
                      {{ "PAYMENT.AUTHENTICATE_FACE_TOUCH_ID" | translate }}
                    </p>
                    <div
                      class="mt-6 flex items-center justify-center gap-2 text-gray-600"
                    >
                      <span class="material-icons text-sm">verified_user</span>
                      <span class="text-xs">{{
                        "PAYMENT.PROTECTED_BY_APPLE_PAY" | translate
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Right Section -->
        <div class="w-full lg:w-[350px] flex-shrink-0">
          <div
            class="bg-white rounded-xl shadow-sm p-6 sticky top-8 border mt-6 lg:mt-0"
          >
            <div class="flex justify-center mb-4">
              <svg
                width="56"
                height="56"
                viewBox="0 0 56 56"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="56" height="56" rx="28" fill="#CBFBF1" />
                <path
                  d="M37.333 19.834H18.6663C17.3777 19.834 16.333 20.8787 16.333 22.1673V33.834C16.333 35.1226 17.3777 36.1673 18.6663 36.1673H37.333C38.6217 36.1673 39.6663 35.1226 39.6663 33.834V22.1673C39.6663 20.8787 38.6217 19.834 37.333 19.834Z"
                  stroke="#009689"
                  stroke-width="2.33333"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M16.333 25.666H39.6663"
                  stroke="#009689"
                  stroke-width="2.33333"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <h3 class="text-center text-lg font-semibold text-black mb-2">
              {{ "PAYMENT.SECURE_PAYMENT" | translate }}
            </h3>
            <p class="text-center text-sm text-gray-600 mb-6">
              {{ "PAYMENT.SSL_ENCRYPTION" | translate }}
            </p>

            <div class="bg-gray-50 rounded-lg p-4 mb-6">
              <p class="text-2xl font-bold text-[#009689] text-center">
                {{ costBreakdown.total | number : "1.2-2" }} SAR
              </p>
              <p class="text-sm text-gray-600 text-center mt-1">
                {{ "PAYMENT.TOTAL_AMOUNT" | translate }}
              </p>
            </div>

            <button
              type="button"
              [disabled]="!isFormValid()"
              [class.opacity-50]="!isFormValid()"
              [class.cursor-not-allowed]="!isFormValid()"
              class="w-full bg-teal-600 hover:bg-teal-500 disabled:hover:bg-teal-600 text-white py-3 rounded-md transition font-medium mb-4"
              (click)="completePayment()"
            >
              {{ getPaymentButtonText() | translate }}
            </button>

            <p class="text-xs text-center text-gray-500">
              {{ "PAYMENT.BY_COMPLETING_PURCHASE" | translate }}
              <a href="#" class="text-teal-600 hover:underline">{{
                "PAYMENT.TERMS_OF_SERVICE" | translate
              }}</a>
              and
              <a href="#" class="text-teal-600 hover:underline">{{
                "PAYMENT.PRIVACY_POLICY" | translate
              }}</a
              >.
            </p>
          </div>
        </div>
      </div>

      <!-- Navigation Buttons -->
      <div class="flex items-center justify-between mt-8 flex-wrap gap-3">
        <button
          type="button"
          class="flex items-center px-4 py-2 text-black bg-white border border-gray-300 rounded-md hover:bg-gray-50 font-medium gap-2"
          (click)="navigateToQuotations()"
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.00033 11.0827L2.91699 6.99935L7.00033 2.91602"
              stroke="currentColor"
              stroke-width="1.16667"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M11.0837 7H2.91699"
              stroke="currentColor"
              stroke-width="1.16667"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          {{ "PAYMENT.BACK_TO_SELECT_QUOTE" | translate }}
        </button>
      </div>
    </div>
  </div>
</main>
